<template>
   <v-card
    class="elevation-6 border-1"
    :href="url"
    target="_blank"
    @click="$track('search_view', 'search')"
  >
    <!-- max-width="374" -->
    <v-img
      v-if="pic"
      class="border-bottom"
      height="193"
      :src="picUrl"
    ></v-img>

    <!-- <v-card-text>
      <v-chip-group>
        <v-chip disabled>Maldito bulo</v-chip>
      </v-chip-group>
    </v-card-text> -->

    <v-card-title>
      {{ title }}
    </v-card-title>
  </v-card>
</template>

<style scoped>
  .v-card:hover {
    box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.16) !important;
    transition: all .2s;
  }

  .elevation-6 {
    box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.06) !important;
  }
  >>>.v-card__title {
      align-items: center;
      display: flex;
      flex-wrap: wrap;
      font-size: 1rem;
      font-weight: 500;
      letter-spacing: 0.0125em;
      line-height: 1.4rem;
      word-break: break-word;
  }
  /*.v-card {
    max-width: 374px;
  }*/

  .v-card__title {
    word-break: break-word;
  }
</style>

<script>
export default {
  name: 'SearchItem',
  props: {
    title: {
      type: String,
      default: '',
    },
    pic: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: '',
    },
  },
  computed: {
    picUrl() {
      if (this.pic.indexOf('://') === -1) {
        return `https://backend.maldita.es/uploads/debunks/${this.pic}`;
      }

      return this.pic;
    },
  },
};
</script>
